module.exports = __webpack_public_path__ + "static/media/img4.8c3719d8.jpg";